import React from 'react';
import { LayersIcon } from 'lucide-react';
const links = [{
  label: 'Términos de Servicio',
  href: '#terminos'
}, {
  label: 'Política de Privacidad',
  href: '#privacidad'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Footer() {
  return <footer className="w-full bg-gray-50 py-14 md:py-16" data-id="element-93" data-mp="32m1bozwzl2p5">
      <div className="mx-auto w-full max-w-4xl px-5 text-center md:px-8" data-id="element-94" data-mp="36q9354utwwr2">
        <p className="inline-flex items-center gap-2 text-base font-extrabold uppercase tracking-wider text-blue-600 md:text-lg" data-id="element-95" data-mp="3ueim7z0nr6ei">
          <LayersIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-96" data-mp="37fpks21w7ww" />
          Atlas Visual de Instrumentación Quirúrgica
        </p>

        <p className="mx-auto mt-5 max-w-xl text-gray-600" data-id="element-97" data-mp="3lgon6gbidynn">
          Material digital | Acceso inmediato | Garantía de satisfacción 7 días
        </p>

        <p className="mx-auto mt-6 max-w-2xl text-sm leading-relaxed text-gray-500" data-id="element-98" data-mp="29ydvdx2r0y8b">
          Material educativo y de consulta visual. Las denominaciones, presentaciones y aplicaciones
          pueden variar según fabricante, institución, procedimiento y país. No sustituye la
          formación profesional, los protocolos institucionales ni las instrucciones del fabricante.
        </p>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-gray-600" data-id="element-99" data-mp="3v8rgds97n3wp">
          {links.map(link => <li key={link.label} data-id="element-100" data-mp="3qaq17iewnoqi">
              <a href={link.href} className="rounded transition-colors duration-150 ease-out hover:text-blue-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-300" data-id="element-101" data-mp="82ienymgqkhh">
                {link.label}
              </a>
            </li>)}
        </ul>

        <p className="mt-10 border-t border-gray-200 pt-6 text-sm text-gray-500" data-id="element-102" data-mp="cus1h5sa74fj">
          © 2026 Atlas Visual de Instrumentación Quirúrgica. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}